import { post, get, put, del } from '../axiosconfig'

import qs from 'qs';
export default {
  // 应用标签
  tagsImage(params) {
    params = qs.stringify(params)
    return get('/zsc/web/image/tags', params)
  },
  // 应用列表
  studiosImage(params) {
    // params = qs.stringify(params)
    return get('/zsc/web/image/studios', params)
  },
  // 应用详情
  studioImage(params) {
    params = qs.stringify(params)
    return get('/zsc/web/image/studio', params)
  },
  // 点赞收藏
  markImage(params) {
    return post('/zsc/web/image/mark',params)
  },
}



// WEBPACK FOOTER //
// ./src/api/public/imageCenter.js